/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';

class SystemHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageLoading: false,
    };
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.props.state.company.useUpdatersMenu();
      this.props.state.company.fetchCompanySettings();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  render() {
    const activeClassName = 'active';
    const { state, t } = this.props;

    const companyStore = toJS(state.company);

    const renderSystemElem = (element) => {
      const objArray = [];
      if (Array.isArray(Object.keys(companyStore.systemObj))) {
        Object.keys(companyStore.systemObj).forEach((key) => {
          objArray.push(companyStore.systemObj[key]);
        });
      }
      return objArray.indexOf(true) > -1 ? element : null;
    };

    const renderAwsElem = (element) => {
      const objArray = [];
      if (Array.isArray(Object.keys(companyStore.awsObj))) {
        Object.keys(companyStore.awsObj).forEach((key) => {
          objArray.push(companyStore.awsObj[key]);
        });
      }
      return objArray.indexOf(true) > -1 ? element : null;
    };

    //awsObj

    return (
      <div className="setting_header ">
        <div className="setting_header_inner">
          <div className="setting_header_box">
            <nav className="setting_lnb">
              {companyStore.isUseLoadBalancer && (
                <NavLink
                  to="/systems/web_server"
                  className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
                  end
                >
                  {t('system.menu.web_server')}
                </NavLink>
              )}
              {state.user.isAdmin && (
                <NavLink to="/systems/ldap" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                  {t('system.menu.ldap')}
                </NavLink>
              )}
              {state.user.isAdmin && (
                <NavLink to="/systems/smtp" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                  {t('system.menu.smtp')}
                </NavLink>
              )}
              {
                renderAwsElem(
                  <NavLink to="/systems/aws" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                    {t('system.menu.aws')}
                  </NavLink>
                )
              }
              {/**
                <Link to="systems/customdb" activeClassName="active">Custom DB</Link>
              */}
              <NavLink to="/systems/license" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                {t('system.menu.license_storage')}
              </NavLink>
              {
                renderSystemElem(
                  <NavLink to="/systems/system" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                    {t('system.menu.system')}
                  </NavLink>
                )
              }
              {
                state.user.isAdmin && (
                  <NavLink to="/systems/security" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                    {t('system.menu.web_security')}
                  </NavLink>
                )
              }
              {
                state.user.isAdmin && (
                  <NavLink to="/systems/timezone" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                    {t('system.menu.time_zone')}
                  </NavLink>
                )
              }
              {companyStore.isUseUpdater && (
                <NavLink to="/systems/update" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }} end>
                  {t('system.menu.update')}
                </NavLink>
              )}
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default WithRouter((withTranslation()(inject('state')(observer(SystemHeader)))));
